module.exports = __webpack_public_path__ + "media/images/icon-board-1f5165d3b22735bce31bdb31609c21b9.png";